module.exports = "/_next/static/images/StreamlineCompliance-dfa18768130ba32d778f93332958a5a4.png";